import script from "./redes.vue?vue&type=script&setup=true&lang=js"
export * from "./redes.vue?vue&type=script&setup=true&lang=js"

import "./redes.vue?vue&type=style&index=0&id=00ab892c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00ab892c"]])

export default __exports__